import { useContext } from 'react';
import InlineOptions from '../../inline-options';
import Chart from '../../chart';
import Divider from '../../divider';
import './open-interest-styles.scss';
import { OpenInterestContext } from '../../../../providers/widgets/open-interest-provider/open-interest-provider';
import { useProcessOpenInterestData } from './hooks/use-process-open-interest-data';
import moment from 'moment';
import TimestampInfo from '../../timestamp-info';
import usePersistentState from '../../../../providers/use-persistent-state';

type OpenInterestContentProps = {
  providerKey: string;
};

const venueOptions = [{ value: 'deribit', label: 'Deribit' }];

const OpenInterestContent = ({ providerKey }: OpenInterestContentProps) => {
  const {
    data,
    isLoading,
    expiryList,
    token,
    venue,
    expiry,
    setSelectedVenue,
    setExpiry,
    timestamp,
  } = useContext(OpenInterestContext);

  const expiryOptions = [
    { value: 'all', label: 'All expires' },
    ...(expiryList?.map((expiry) => ({
      value: expiry,
      label: moment(expiry).format('YYYY-MM-DD') || expiry,
    })) || []),
  ];

  const { xAxis, yAxis, series } = useProcessOpenInterestData({
    data,
    venue,
    expiry,
    token,
  });

  const [legendSelected, setLegendSelected] = usePersistentState<Record<string, boolean>>(
    [providerKey, 'OPEN-INTEREST'],
    'legendSelected',
    {},
  );

  const renderInlineOptions = () => (
    <div className="open-interest-header">
      <InlineOptions
        options={venueOptions}
        selectedOption={venue}
        onOptionChange={(val) => setSelectedVenue(val as string)}
        maxVisibleOptions={5}
      />
      <Divider />
      <InlineOptions
        options={expiryOptions}
        selectedOption={expiry}
        onOptionChange={(val) => setExpiry(val as string)}
        maxVisibleOptions={5}
      />
    </div>
  );

  return (
    <div className="open-interest-widget-container">
      {renderInlineOptions()}
      <div className="open-interest-timestamp">
        <TimestampInfo timestamp={new Date(timestamp).getTime()} />
      </div>
      <div className="open-interest-chart">
        <Chart
          series={series}
          isLoading={isLoading}
          xAxis={xAxis}
          yAxis={yAxis}
          grid={{ bottom: 20, right: 0, left: 10 }}
          merge={false}
          legend={{
            selected: legendSelected,
          }}
          onLegendSelectChanged={(payload) => setLegendSelected(payload.selected || {})}
        />
      </div>
    </div>
  );
};

export default OpenInterestContent;
